<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-md-12 px-1" v-if="statusSnack.snack">
        <v-snackbar
          v-model="statusSnack.snack"
          :timeout="3000"
          :color="statusSnack.snackColor"
        >
          {{ statusSnack.snackText }}
          <v-btn text @click="resetStatusSnack()">Close</v-btn>
        </v-snackbar>
      </div>
    </div>
    <v-data-table
      :headers="headers"
      :items="advisors"
      sort-by="calories"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Advisors List</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                New Advisor
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="editedItem.advsr_email_addr"
                        label="Email"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="editedItem.advsr_pers_fname"
                        label="First Name"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="editedItem.advsr_pers_lname"
                        label="Last Name"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="editedItem.advsr_uin"
                        label="UIN"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" text @click="save"> Save </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5"
                >Are you sure you want to delete this item?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
      <template v-slot:no-data>
        <v-progress-linear indeterminate color="teal"></v-progress-linear>
      </template>
    </v-data-table>
  </div>
</template>

              <style>
</style>


<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: "Email",
        align: "start",
        sortable: true,
        value: "advsr_email_addr",
      },
      { text: "First Name", value: "advsr_pers_fname" },
      { text: "Last Name", value: "advsr_pers_lname" },
      { text: "UIN", value: "advsr_uin" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    advisors: [],
    editedIndex: -1,
    editedItem: {
      advsr_email_addr: "",
      advsr_pers_fname: "",
      advsr_pers_lname: "",
      advsr_uin: "",
    },
    defaultItem: {
      advsr_email_addr: "",
      advsr_pers_fname: "",
      advsr_pers_lname: "",
      advsr_uin: "",
    },
    colors: [
      "blue",
      "indigo",
      "deep-purple",
      "cyan",
      "green",
      "orange",
      "grey darken-1",
    ],
  }),

  computed: {
    ...mapState({
      statusfromStore: (state) => state.status,
    }),
    formTitle() {
      return this.editedIndex === -1 ? "New Advisor" : "Edit Advisors";
    },
    statusSnack: {
      get() {
        return this.statusfromStore;
      },
      set(newName) {
        return newName;
      },
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    statusSnack: function (val) {
      this.statusSnack = val;
    },
  },

  created() {
    this.initialize();
  },
  mounted() {},

  methods: {
    resetStatusSnack() {
      this.$store.commit("status/setStatus", {
        snack: false,
        snackColor: "",
        snackText: "",
      });
    },
    async initialize() {
      await axios
        .get("/api/v1/advisors/")
        .then((response) => {
          this.advisors = response.data.data;
          this.$store.commit("status/setStatus", {
            snack: true,
            snackColor: "success",
            snackText: response.data.message,
          });
        })
        .catch((error) => {
          var msg = "something went wrong";
          this.$store.commit("status/setStatus", {
            snack: true,
            snackColor: "error",
            snackText: msg,
          });
        });
    },
    async editItem(item) {
      this.editedIndex = this.advisors.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    async deleteItem(item) {
      this.editedIndex = this.advisors.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      this.advisors.splice(this.editedIndex, 1);
      this.closeDelete();
      await axios
        .delete("/api/v1/advisor/" + this.editedItem.id)
        .then((response) => {
          console.warn(response);
          this.$store.commit("status/setStatus", {
            snack: true,
            snackColor: "success",
            snackText: response.data.message,
          });
        })
        .catch((error) => {
          var msg = "something went wrong";
          this.$store.commit("status/setStatus", {
            snack: true,
            snackColor: "error",
            snackText: msg,
          });
        });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      this.close();
      if (this.editedIndex > -1) {
        Object.assign(this.advisors[this.editedIndex], this.editedItem);
        await axios
          .patch(
              "/api/v1/advisor/" +
              this.advisors[this.editedIndex].id,
            this.editedItem
          )
          .then((response) => {
            this.$store.commit("status/setStatus", {
              snack: true,
              snackColor: "success",
              snackText: response.data.message,
            });
          })
          .catch((error) => {
            var msg = "something went wrong";
            this.$store.commit("status/setStatus", {
              snack: true,
              snackColor: "error",
              snackText: msg,
            });
          });
      } else {
        this.advisors.push(this.editedItem);
        await axios
          .post("/api/v1/advisors/", this.editedItem)
          .then((response) => {
            this.$store.commit("status/setStatus", {
              snack: true,
              snackColor: "success",
              snackText: response.data.message,
            });
          })
          .catch((error) => {
            var msg = "something went wrong";
            this.$store.commit("status/setStatus", {
              snack: true,
              snackColor: "error",
              snackText: msg,
            });
          });
      }
    },
  },
};
</script>
